/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ApiKeysListKeysResponse = {
  result: components.V1ApiKeysListKeysResponseBody;
};

/** @internal */
export const ApiKeysListKeysResponse$inboundSchema: z.ZodType<
  ApiKeysListKeysResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Result: components.V1ApiKeysListKeysResponseBody$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "Result": "result",
  });
});

export function apiKeysListKeysResponseFromJSON(
  jsonString: string,
): SafeParseResult<ApiKeysListKeysResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ApiKeysListKeysResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ApiKeysListKeysResponse' from JSON`,
  );
}
